import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedMonth: "",
  selectedYear: "",
  status: "fetching",
  selectedCategory: "all",
  selectedSubcategory: "all",
  selectedType: "all",
  selectedPostcode: "",
  selectedLocation: [],
  selectedProvider: "all",
  filteredCourseDates: [],
};

const CourseCalendarSlice = createSlice({
  name: "calendar course",
  initialState,
  reducers: {
    selectMonth(state, action) {
      state.selectedMonth = action.payload;
    },
    selectYear(state, action) {
      state.selectedYear = action.payload;
    },
    selectCategory(state, action) {
      state.selectedCategory = action.payload;
      state.selectedSubcategory = initialState.selectedSubcategory;
    },
    selectSubcategory(state, action) {
      state.selectedSubcategory = action.payload;
    },
    selectType(state, action) {
      state.selectedType = action.payload;
    },
    selectPostcode(state, action) {
      state.selectedPostcode = action.payload;
    },
    selectLocation(state, action) {
      state.selectedLocation = action.payload;
    },
    deselectLocation(state, action) {
      state.selectedLocation = state.selectedLocation.filter(
        (location) => location !== action.payload
      );
    },
    resetLocations(state) {
      state.selectedLocation = [];
    },
    selectProvider(state, action) {
      state.selectedProvider = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setCourseDates(state, action) {
      state.filteredCourseDates = action.payload;
    },
  },
});

export const {
  selectMonth,
  selectYear,
  selectCategory,
  selectSubcategory,
  selectType,
  selectPostcode,
  selectLocation,
  deselectLocation,
  resetLocations,
  selectProvider,
  setStatus,
  setCourseDates,
} = CourseCalendarSlice.actions;

export default CourseCalendarSlice.reducer;
